<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="mb-0">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar Tipo de Turno</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-alert
            v-if="esPorDefecto"
            class="mt-4"
            color="purple"
            dark
            outlined
            dismissible
          >
            Está editando el único Tipo de Turno, por lo cual no podrá cambiar
            el tipo de turno por defecto.
          </v-alert>
          <v-row dense class="mt-3">
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="nombreTipoTurno"
                prepend-icon="mdi-account"
                label="Nombre Tipo de Turno *"
                maxlength="80"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="9" sm="4" md="2">
              <v-text-field
                v-model="sigla"
                prepend-icon="mdi-account"
                label="Sigla"
                maxlength="3"
                dense
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" md="6" class="tipo-turno-checkboxes">
              <v-checkbox
                class="ml-4 mt-2"
                v-model="porDefecto"
                label="Es tipo de turno por defecto"
                color="primary"
                :disabled="esPorDefecto"
                hide-details
              ></v-checkbox>
              <v-checkbox
                class="ml-4 mt-2"
                v-model="esTurnoFijo"
                label="Es Turno Fijo"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <v-select
                :items="intervalos"
                prepend-icon="mdi-calendar-multiple"
                v-model="duracion"
                label="Duración Turno (Para Turnos Web)"
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <v-checkbox
                class="ml-4 mt-2"
                v-model="requiereProfesor"
                label="Requiere profesor en turno"
                color="primary"
                hide-details
              ></v-checkbox
            ></v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="total"
                prepend-icon="mdi-currency-usd"
                label="Valor por jugador"
                @blur="toFixed"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarTipoTurno"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    nombreTipoTurno: null,
    porDefecto: false,
    disponibleWeb: false,
    requiereProfesor: false,
    esTurnoFijo: false,
    sigla: "",
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    duracion: 1,
    intervalos: [1, 2, 3, 4, 5, 6],
    total: null,
  }),

  props: {
    visible: {
      type: Boolean,
    },
    esPorDefecto: {
      type: Boolean,
    },
    idTipoTurno: {
      type: Number,
    },
  },

  computed: {
    show: {
      get() {
        this.porDefecto = this.esPorDefecto;
        if (this.visible) this.buscarDatosTipoTurno();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    buscarDatosTipoTurno() {
      let self = this;

      axios
        .get("/Profesional/BuscarDatosTipoTurno?", {
          params: {
            idTipoTurno: this.idTipoTurno,
          },
        })
        .then((response) => {
          self.nombreTipoTurno = response.data.nombreTipoTurno;
          self.porDefecto = response.data.porDefecto;
          self.sigla = response.data.sigla;
          self.disponibleWeb = response.data.disponibleWeb;
          self.duracion = response.data.duracion;
          self.requiereProfesor = response.data.requiereProfesor;
          self.total = response.data.total;
          self.esTurnoFijo = response.data.esTurnoFijo;
        })
        .catch((error) => {});
    },
    modificarTipoTurno() {
      this.$swal({
        title: "Modificar Tipo de Turno",
        text: "¿Desea modificar el tipo de turno?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosTipoTurno = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idTipoTurno: this.idTipoTurno,
            nombreTipoTurno: this.nombreTipoTurno,
            porDefecto: this.porDefecto,
            sigla: this.sigla,
            disponibleWeb: false, // siempre false desde el front
            duracion: this.duracion,
            requiereProfesor: this.requiereProfesor,
            total: this.total,
            esTurnoFijo: this.esTurnoFijo,
          };
          let self = this;
          axios
            .post("/Profesional/ModificarTipoTurno", datosTipoTurno)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title:
                    "Ya existe un tipo de turno registrado con ese nombre.",
                  vm: self,
                  timer: 2000,
                });
              } else {
                self.$refs.form.resetValidation();

                document.getElementsByClassName(
                  "v-dialog--active",
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Tipo de Turno modificado exitosamente.",
                  vm: self,
                  timer: 2000,
                });
                self.$emit("tipoTurnoModificado");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El Tipo de Turno no pudo ser modificado.",
                vm: this,
                timer: 2000,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
<style scoped lang="scss">
.tipo-turno-checkboxes {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
</style>
